import { render, staticRenderFns } from "./InputCodeName.vue?vue&type=template&id=87b567ca&"
import script from "./InputCodeName.vue?vue&type=script&lang=ts&"
export * from "./InputCodeName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports